import { atom } from 'recoil';
import { IBoardSet } from '@typings/menu/boardSetType';

// 보드셋 리스트를 위한 전역 상태
export const boardSetListState = atom<IBoardSet[] | null>({
  key: 'boardSetListState',
  default: null,
});

// 보드셋 리스트 로딩 상태
export const boardSetListLoadingState = atom<boolean>({
  key: 'boardSetListLoadingState',
  default: true,
}); 